module.exports = __webpack_public_path__ + "img/pay_online_new.37a87e4e.png";